'use strict';
var ACC;
ACC.megamenu2 = {

    _autoload: [
        'initTopNavigation',
        'addLinkToNavigationBannerImage',
        'initMegaMenuGAEvents',
    ],

    _const: {
        CLASS_IS_ACTIVE: 'is-active',
        CLASS_BG_TRANSPARENT: 'bg-transparent',
        CLASS_EXPAND_BUTTON_ICON_DOWN: 'icon-down-open-mini',
        CLASS_EXPAND_BUTTON_ICON_UP: 'icon-up-open-mini',

        SELECTOR_TOP_NAVIGATION: '.top-navigation',
        SELECTOR_LEVEL_1_ITEM: '.l1-navigation-item',
        SELECTOR_LEVEL_1_EXPAND_BUTTON: '.l1-navigation-item__expand-button',
        SELECTOR_LEVEL_1_EXPAND_BUTTON_ICON: '.l1-navigation-item__expand-button__icon',
        SELECTOR_LEVEL_2_MAVIGATION_CONTAINER: '.l2-navigation-container',
        SELECTOR_LEVEL_2_ITEM: '.l2-navigation-item',
        SELECTOR_LEVEL_2_BANNER: '.l2-banner'
    },

    initTopNavigation: function() {
        var self = this;
        var isMegaMenuVisible =  false;
        var isTouch = 'ontouchstart' in window ||
            (window.DocumentTouch && document instanceof window.DocumentTouch) ||
            navigator.maxTouchPoints > 0 ||
            window.navigator.msMaxTouchPoints > 0;

        $(self._const.SELECTOR_TOP_NAVIGATION).hoverIntent({
            over: function() {
                var $l1_hoveredItem = $(this).find(self._const.SELECTOR_LEVEL_1_ITEM + ':hover');
                if ($l1_hoveredItem.length) {
                    self.hideMegaMenu();
                    self.showMegaMenu($l1_hoveredItem);
                }
                isMegaMenuVisible = true;
            },
            out: function() {
                var $l1_hoveredItem = $(this).find(self._const.SELECTOR_LEVEL_1_ITEM + ':hover');
                if (!$l1_hoveredItem.length) {
                    self.hideMegaMenu();

                    // ABANDON - ANALYTICS (DESKTOP)
                    ACC.gtm.trackMegaMenu_Abandon();
                }
                isMegaMenuVisible = false;
            },
            timeout: 200
        })

        $(self._const.SELECTOR_LEVEL_1_ITEM).on('mouseenter', function() {
            if ($(this).hasClass(self._const.CLASS_IS_ACTIVE)) return;
            if (isMegaMenuVisible) {
                self.hideMegaMenu();
                self.showMegaMenu($(this));
            }
        });

        $(self._const.SELECTOR_LEVEL_1_ITEM).on('focusin', '> a', function() {
            self.hideMegaMenu();
        })

        /**
         * When Expand button is selected, open sub-navigation & focus first corresponding element
         */
        $(self._const.SELECTOR_LEVEL_1_ITEM).on('click', self._const.SELECTOR_LEVEL_1_EXPAND_BUTTON, function(e) {
            var $l1_navigationItem = $(e.delegateTarget);
            var $l1_expandButton = $(e.currentTarget);
            var shouldExpand = $l1_expandButton.attr('aria-expanded') === 'false';

            // Reset Megamenu
            self.hideMegaMenu();

            // Show corresponding Megamenu dropdown
            if (shouldExpand) {
                self.showMegaMenu($l1_navigationItem);
            }
        });

        /**
         * When Escape Key is pressed, close Mega Menu and return focus to Expand Button
         */
        $(self._const.SELECTOR_LEVEL_1_ITEM).on('keydown', `${self._const.SELECTOR_LEVEL_1_EXPAND_BUTTON}, ${self._const.SELECTOR_LEVEL_2_MAVIGATION_CONTAINER}`, function(e) {
            // Escape Key
            if (e.which === 27) {
                self.hideMegaMenu();
                $(e.delegateTarget).find(self._const.SELECTOR_LEVEL_1_EXPAND_BUTTON).focus();

                // ABANDON - ANALYTICS (DESKTOP)
                ACC.gtm.trackMegaMenu_Abandon();
            }
        });

        /**
         * When Tab Key is pressed on the last L2 item, close the MM
         */
        $(self._const.SELECTOR_LEVEL_1_ITEM).on('keydown', `a:last`, function(e) {
            // Tab
            if (e.which === 9 && e.shiftKey === false) {
                self.hideMegaMenu();

                // ABANDON - ANALYTICS (DESKTOP)
                ACC.gtm.trackMegaMenu_Abandon();
            }
        });

        /**
         * Expand Mega Menu on Touch for large screen tablets
         */
        if (isTouch) {
            $(self._const.SELECTOR_LEVEL_1_ITEM).on('touchstart', '> a', function(e) {
                var $l1_navigationItem = $(e.delegateTarget);
                if (!$l1_navigationItem.hasClass(self._const.CLASS_IS_ACTIVE)) {
                    e.preventDefault();
                    self.hideMegaMenu();
                    self.showMegaMenu($l1_navigationItem);
                }
            });

            $(document).on('touchstart', function(e) {
                var touchTarget = e.target;
                var $l1_activeNavigationItem = $(`${self._const.SELECTOR_LEVEL_1_ITEM}.${self._const.CLASS_IS_ACTIVE}`);
                if ($l1_activeNavigationItem.length > 0 && !$l1_activeNavigationItem.is(touchTarget) && $l1_activeNavigationItem.has(touchTarget).length === 0) {
                    self.hideMegaMenu();

                    // ABANDON - ANALYTICS (DESKTOP)
                    ACC.gtm.trackMegaMenu_Abandon();
                }
            });
        }
    },

    showMegaMenu: function($element) {
        var $expandButton = $element.find(this._const.SELECTOR_LEVEL_1_EXPAND_BUTTON);
        var $expandButtonIcon = $expandButton.find(this._const.SELECTOR_LEVEL_1_EXPAND_BUTTON_ICON);
        var $l2_navigationContainer = $element.find(this._const.SELECTOR_LEVEL_2_MAVIGATION_CONTAINER);

        $element.addClass(this._const.CLASS_IS_ACTIVE);
        $l2_navigationContainer.scrollTop(0);
        $expandButton.attr('aria-expanded', 'true');
        $expandButtonIcon
            .removeClass(this._const.CLASS_EXPAND_BUTTON_ICON_DOWN)
            .addClass(this._const.CLASS_EXPAND_BUTTON_ICON_UP);

        $('.main-content .layer').addClass(this._const.CLASS_BG_TRANSPARENT);
    },

    hideMegaMenu: function() {
        $(this._const.SELECTOR_LEVEL_1_ITEM).removeClass(this._const.CLASS_IS_ACTIVE);
        $(this._const.SELECTOR_LEVEL_1_EXPAND_BUTTON).attr('aria-expanded', 'false');
        $(this._const.SELECTOR_LEVEL_1_EXPAND_BUTTON_ICON)
            .removeClass(this._const.CLASS_EXPAND_BUTTON_ICON_UP)
            .addClass(this._const.CLASS_EXPAND_BUTTON_ICON_DOWN);

        $('.main-content .layer').removeClass(this._const.CLASS_BG_TRANSPARENT);
    },

    initMegaMenuGAEvents: function() {
        $(this._const.SELECTOR_LEVEL_1_ITEM).on('click', '> a', function(e) {
            e.preventDefault();

            var $l1_navigationItem = $(e.delegateTarget);
            var $l1_linkElement = $(e.currentTarget);

            var L0_CATEGORY = $l1_navigationItem.data('l0-category');
            var URL = $l1_linkElement[0].href;

            ACC.gtm.trackMegaMenu_L0(L0_CATEGORY, URL);
        })

        $(this._const.SELECTOR_LEVEL_2_ITEM).on('click', '> a', function(e) {
            e.preventDefault();

            var $l2_navigationItem = $(e.delegateTarget);
            var $l2_linkElement = $(e.currentTarget);

            var L0_CATEGORY = $l2_navigationItem.data('l0-category');
            var L1_CATEGORY = $l2_navigationItem.data('l1-category');
            var L2_CATEGORY = $l2_navigationItem.data('l2-category');
            var URL = $l2_linkElement[0].href;

            ACC.gtm.trackMegaMenu_L2(L0_CATEGORY, L1_CATEGORY, L2_CATEGORY, URL);
        })

        // triggered when the user clicks on either an L2 image or the L2 link for the image
        $(this._const.SELECTOR_LEVEL_2_BANNER).on('click', '> a', function(e) {
            e.preventDefault();

            const $l2_navigationItem = $(e.delegateTarget);
            const $l2_linkElement = $(e.currentTarget);
            const $clickedElement = $(e.target); 
            const linkTitle = $l2_linkElement.attr('title');

            const L0_CATEGORY = $l2_navigationItem.data('l0-category');
            const L1_CATEGORY = $l2_navigationItem.data('l1-category');
            const L2_CATEGORY = (linkTitle === $l2_navigationItem.data('l2-category-link2'))
                                ? $l2_navigationItem.data('l2-category-link2')
                                : $l2_navigationItem.data('l2-category-link1');
            const URL = $l2_linkElement[0].href;           

            ACC.gtm.trackMegaMenu_L2(L0_CATEGORY, L1_CATEGORY, L2_CATEGORY, URL);           
        });
    },

    // make the banner image clickable - use the first link inside the banner
    addLinkToNavigationBannerImage: function() {
        $(this._const.SELECTOR_LEVEL_2_BANNER).each(function(i, l2_banner) {
            var $imageElement = $(l2_banner).find('img').first();
            var $linkElement = $(l2_banner).find('a').first();
            if ($imageElement.length && $linkElement.length) {
                $imageElement.wrap($linkElement.clone().empty())
            }
        });
    }
};
